import { render, staticRenderFns } from "./bmInfo.vue?vue&type=template&id=d8f19fe6&scoped=true"
import script from "./bmInfo.vue?vue&type=script&lang=js"
export * from "./bmInfo.vue?vue&type=script&lang=js"
import style0 from "./bmInfo.vue?vue&type=style&index=0&id=d8f19fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f19fe6",
  null
  
)

export default component.exports